import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'

export function useOnClose(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)

  return function onClick() {
    setFlowTo(normalizePath(props.viewPath, '../No'))
  }
}
